/**
 * Parse a value into boolean with robust handling.
 * Accepts: true/false, 1/0, yes/no, on/off (case-insensitive).
 * Falls back to defaultValue if value is null/undefined/empty or unparsable.
 */
export function parseBoolean(value: unknown, defaultValue = false): boolean {
  if (value === undefined || value === null || value === '') return defaultValue

  const str = String(value).trim().toLowerCase()

  if (['true', '1', 'yes', 'on'].includes(str)) return true
  if (['false', '0', 'no', 'off'].includes(str)) return false

  return defaultValue
}
